import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe para formatear moneda personalizado
 * Uso: {{ value | currencyFormat }}
 */
@Pipe({
  name: 'currencyFormat',
  standalone: true
})
export class CurrencyFormatPipe implements PipeTransform {
  transform(value: number | string, symbol: string = '$', decimals: number = 2, argentine: boolean = false): string {
    if (value === null || value === undefined || value === '') {
      return '-';
    }

    const numValue = typeof value === 'string' ? parseFloat(value) : value;

    if (isNaN(numValue)) {
      return '-';
    }

    let formattedValue = numValue.toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    if (argentine) {
      formattedValue = formattedValue.replace(/\.(\d+)$/, ',$1');
    }
    return `${symbol} ${formattedValue}`;
  }
}

